import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import { getFormattedPrice } from '../../helpers/price';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form33b(props: Props) {
  const { control, register, handleSubmit, errors, watch } = useForm({
    defaultValues: replaceDefaultValues(
      {
        pricesProperty: '',
        pricesPenaltyFee: '',
        pricesCreditQuote: '',
        pricesMonthlyInterest: '',
      },
      props.defaultValues
    ),
  });

  const watchPricesProperty = watch('pricesProperty');
  const penaltyFeeMax = (Number(watchPricesProperty) || 0) * 0.1 * 0.3;

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Valores</h1>

      <FormElement
        name="pricesProperty"
        label="Valor de la propiedad*"
        elementType="price"
        control={control}
        rules={{ required: true }}
        error={errors.pricesProperty}
      />

      <FormElement
        name="pricesMonthlyInterest"
        label="Valor cuota mensual de cuota inicial*"
        elementType="price"
        control={control}
        rules={{ required: true }}
        error={errors.pricesMonthlyInterest}
      />

      <FormElement
        name="pricesCreditQuote"
        label="Número de cuotas de cuota inicial*"
        elementType="number"
        inputRef={register({ required: true })}
        error={errors.pricesCreditQuote}
      />

      <FormElement
        name="pricesPenaltyFee"
        label="Valor cláusula penal*"
        subLabel={<>Valor máximo de {getFormattedPrice(penaltyFeeMax)}</>}
        elementType="price"
        control={control}
        rules={{ required: true, min: 0, max: penaltyFeeMax }}
        error={errors.pricesPenaltyFee && 'Valor incorrecto.'}
      />

      <FormElement
        elementType="custom"
        label="Nota: La firma de la promesa de compraventa se le informará al usuario
        de pendiendo del avance de las obras y será firmada a través de la
        plataforma hauscanner.com al igual que la firma de la escritura
        pública de compraventa."
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
